import { cn } from "@/lib/utils";
import { useAssistant } from "@/context/AssistantContext";
import { Conversation } from "./Conversation";

/**
 * Dock surface: a floating panel on the right that leaves the page visible and interactive (no backdrop),
 * so the operator can read the map/plan while the assistant answers. Split and full-screen live elsewhere.
 */
export const AssistantDock = () => {
  const { mode } = useAssistant();
  if (mode !== "dock") return null;
  return (
    <div className={cn("fixed inset-y-3 right-3 z-40 w-[440px] max-w-[calc(100vw-1.5rem)] overflow-hidden rounded-2xl bg-background shadow-[0_0_0_1px_rgba(16,24,40,0.06),0_24px_64px_-24px_rgba(16,24,40,0.45)] fade-up")} data-testid="ai-dock" role="complementary" aria-label="Assistent">
      <Conversation variant="dock" />
    </div>
  );
};
